import { MtmaContact } from './mtma-contact';
import { MtmaKeypad } from './mtma-keypad';
import { MtmaTag } from './mtma-tag';

export class MtmaTimeslice {
    Id: number;
    Name: string;
    Type: number;
    Weekdays: number;
    DtFrom: string;
    DtTo: string;
    Flags: number;
    Access?: boolean;
    Old?: boolean;
    WeekdaysList?: CAWeekDay[];
}

export class MtmaRule {
    Id: number;
    Name: string;
    Flags: number;
    DtFrom: Date;
    DtTo: Date;
    Timeslices?: MtmaTimeslice[];
    WeeklySchedules?: MtmaTimeslice[];
    SpecialPlannings?: MtmaTimeslice[];
}

export class MtmaRuleAccess {
    Contacts: MtmaContact[];
    Keypads: MtmaKeypad[];
    Tags: MtmaTag[];
}

export class CAWeekDay {
    Value: string;
    Name: string;
    Enable: boolean;
}
